/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrescriptionPatientDto
 */
export interface PrescriptionPatientDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    patientId: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    firstName: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    lastName: string;
    /**
     * Patient avatar URL
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    avatarUrl: string;
    /**
     * Patient email
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    email: string;
    /**
     * Patient phone
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    phone: string;
    /**
     * Patient birth date
     * @type {Date}
     * @memberof PrescriptionPatientDto
     */
    birthDate: Date;
    /**
     * Patient status
     * @type {string}
     * @memberof PrescriptionPatientDto
     */
    status: PrescriptionPatientDtoStatusEnum;
}


/**
 * @export
 */
export const PrescriptionPatientDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type PrescriptionPatientDtoStatusEnum = typeof PrescriptionPatientDtoStatusEnum[keyof typeof PrescriptionPatientDtoStatusEnum];


/**
 * Check if a given object implements the PrescriptionPatientDto interface.
 */
export function instanceOfPrescriptionPatientDto(value: object): value is PrescriptionPatientDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PrescriptionPatientDtoFromJSON(json: any): PrescriptionPatientDto {
    return PrescriptionPatientDtoFromJSONTyped(json, false);
}

export function PrescriptionPatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionPatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'avatarUrl': json['avatarUrl'],
        'email': json['email'],
        'phone': json['phone'],
        'birthDate': (new Date(json['birthDate'])),
        'status': json['status'],
    };
}

export function PrescriptionPatientDtoToJSON(json: any): PrescriptionPatientDto {
    return PrescriptionPatientDtoToJSONTyped(json, false);
}

export function PrescriptionPatientDtoToJSONTyped(value?: PrescriptionPatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'avatarUrl': value['avatarUrl'],
        'email': value['email'],
        'phone': value['phone'],
        'birthDate': ((value['birthDate']).toISOString()),
        'status': value['status'],
    };
}

